






















































































































































































































































































































































































/* eslint-disable @typescript-eslint/no-explicit-any */
import Vue from 'vue';
import {
  KojoJotaiKb,
  SumiFlg,
  Flg,
  MukoFlg,
  TorikeshiFlg,
  Color,
  UmuFlg,
  OutStatus,
} from '@/constants/constants';
import { getDefaultPagerInfo } from '@/utils/utils';
import { BUTTON } from '@/constants/label';
import CtrlNormalBtn from '@/components/common/control/CtrlNormalBtn.vue';
import VuePdfEmbed from 'vue-pdf-embed/dist/vue2-pdf-embed';
import CtrlMessageDialog from '@/components/common/control/CtrlMessageDialog.vue';

export default Vue.extend<any, any, any, any>({
  name: 'G_040_HatchuConfirm_Table',
  components: {
    CtrlNormalBtn,
    VuePdfEmbed,
    CtrlMessageDialog,
  },
  props: {
    search: String,
    items: Array,
    value: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({
    headers: [
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '受注日',
        value: 'juchuYmd',
        width: 100,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: 'ｵｰﾀﾞｰ№',
        value: 'orderNo',
        width: 110,
        sortable: true,
      },
      {
        class: 'text-start',
        text: '状態',
        value: 'icon',
        width: 70,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '出荷予定日',
        value: 'shukkaYoteiYmd',
        width: 115,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '納品予定日',
        value: 'nohinYoteiYmd',
        width: 115,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '納品先',
        value: 'nohinsakiMei',
        width: 408,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '入庫倉庫',
        value: 'nyukoSokoMei',
        width: 256,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '集荷先倉庫',
        value: 'shukasakiSokoMei',
        width: 256,
        sortable: true,
      },
      {
        class: 'text-truncate',
        cellClass: 'text-truncate',
        text: '品目（1件目）',
        value: 'himmokuMei',
        width: 450,
        sortable: true,
      },
      {
        class: 'text-end',
        cellClass: 'text-end',
        text: '数量計',
        value: 'suryoSum',
        sortable: true,
        width: 100,
      },
      {
        class: 'text-end',
        cellClass: 'text-end',
        text: '重量計',
        value: 'juryoSum',
        sortable: true,
        width: 100,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '配送区分',
        value: 'haisoKbMei',
        width: 100,
        sortable: true,
      },
      {
        class: 'text-truncate',
        cellClass: 'text-truncate',
        text: '配送会社',
        value: 'haisoKaishaMei',
        width: 340,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '状態名',
        value: 'kojoJotaiKbMei',
        width: 140,
        sortable: true,
      },
      {
        class: 'text-start',
        cellClass: 'text-start',
        text: '発注備考',
        value: 'hatchuBiko',
        sortable: true,
        width: 500,
      },
      { text: '', value: 'action', sortable: false, width: 208 },
    ],
    KojoJotaiKb,
    SumiFlg,
    Flg,
    MukoFlg,
    TorikeshiFlg,
    Color,
    showPreviewPDF: [],
    BUTTON,
    footerProps: {} as any,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    UmuFlg,
    messageShow: false,
    messageId: '',
    messageTextParam: [],
    currentItems: [],
  }),
  methods: {
    handleSelectAll(selectedItem: any) {
      const isSelectedAll =
        this.selected.length &&
        selectedItem.items.every(
          (item: any) =>
            item.chkDispFlg === Flg.FLG_FALSE ||
            this.selected.findIndex(
              (selected: any) => selected.id === item.id
            ) > -1
        );
      if (!isSelectedAll) {
        this.selected = [
          ...this.selected,
          ...selectedItem.items.filter(
            (item: any) => item.chkDispFlg === Flg.FLG_TRUE
          ),
        ];
      } else {
        this.selected = this.selected.filter(
          (item: any) =>
            selectedItem.items.findIndex(
              (select: any) => select.id === item.id
            ) < 0
        );
      }
    },
    // PDF出力
    handlePdfOut(item: any) {
      const linkSource = item.tempShiryo;
      const downloadLink = document.createElement('a');
      downloadLink.href = linkSource;
      downloadLink.download = item.tempFileName;
      downloadLink.click();
    },
    setRowClass(item: any) {
      if (
        item.rowGrayFlg != Flg.FLG_TRUE &&
        item.rowNoticeColorFlg == Flg.FLG_TRUE
      ) {
        return 'cream-background-flag';
      } else if (item.rowGrayFlg === Flg.FLG_TRUE) {
        return 'gray-background-flag';
      }
    },
    //別紙添付データ取得
    getAttachedData(item: any) {
      this.$store.dispatch('common/setIsLoading', true);
      if (item.tempShiryo) {
        this.$set(this.showPreviewPDF, item.id, true);
        this.$store.dispatch('common/setIsLoading', false);
      } else {
        const params = {
          tempEntryYmd: item.tempEntryYmd,
          tempSeq: item.tempSeq,
          tempMukoFlg: item.tempMukoFlg,
        };

        this.$store
          .dispatch('common/getBesshiTemp', params)
          .then((res: any) => {
            if (
              res &&
              res.status == 200 &&
              res.data &&
              res.data.error &&
              res.data.error.outStatus &&
              res.data.error.outStatus != OutStatus.NORMAL
            ) {
              const { error } = res.data;
              this.messageShow = true;
              this.messageId = error.messageID;
              this.messageTextParam = error.messageArgs;
              this.$store.dispatch('common/setIsLoading', false);
              return;
            }
            if (!res.data.responseData) {
              this.messageShow = true;
              this.messageId = 'KI_W124';
              this.messageTextParam = [];
              this.$store.dispatch('common/setIsLoading', false);
              return;
            }
            item.tempShiryo = res.data.responseData.tempShiryo;
            this.$set(this.showPreviewPDF, item.id, true);
            this.$store.dispatch('common/setIsLoading', false);
          });
      }
    },
    handleOkMessage() {
      this.messageShow = false;
      this.messageId = '';
      this.messageTextParam = [];
      this.$emit('dialogOk');
    },
  },
  computed: {
    tableHeight() {
      return this.$vuetify.breakpoint.height - 328;
    },
    selected: {
      get() {
        return this.value;
      },
      set(value: any) {
        this.$emit('input', value);
      },
    },
    indexedItems() {
      return this.items.map((item: any, index: number) => ({
        id: index,
        ...item,
      }));
    },
    changeOrderCount() {
      // Sum up totalCount from the filteredItems
      return this.currentItems.reduce(
        (acc: number, item: any) => acc + (item.changeOrderCount || 0),
        0
      );
    },
    hatchuRenrakuCount() {
      // Sum up totalCount from the filteredItems
      return this.currentItems.reduce(
        (acc: number, item: any) => acc + (item.hatchuRenrakuCount || 0),
        0
      );
    },
    tempCount() {
      // Sum up totalCount from the filteredItems
      return this.currentItems.reduce(
        (acc: number, item: any) => acc + (item.tempCount || 0),
        0
      );
    },
  },
  created() {
    const pagerInfo = getDefaultPagerInfo();
    this.footerProps = pagerInfo.footerProps;
    this.options.itemsPerPage = pagerInfo.itemPerPage;
  },
});
